export const inititalValues = {
  password: '',
  newPassword: '',
};
